export default async function checkRule({ to, nextVue, next, store }) {
    const rules = to.meta.rules

    if (!rules) {
        return next()
    }

    let result = false
    Object.keys(rules).forEach(subject => {
        if(
            rules[subject].filter(
                action => store.getters.ability.can(action, subject)
            ).length > 0
        ) {
            result = true
        }
    })

    return result ? next() : nextVue('/access-denied')
}